/** Gong (WebAudio, E5+H5 — harmonische Quinte+) — 1:1 zu audio-player.js. */
let actx: AudioContext | null = null;

/**
 * Browser starten einen AudioContext „suspended", bis eine echte Nutzer-Geste ihn
 * freischaltet — sonst bleibt der Gong STUMM (Auftraggeber 2026-06-14: „Gong taucht
 * nicht auf"). Bei jeder Steuer-Geste aufwecken. Exportiert, damit der Player ihn
 * auch beim Play-Tipp anstoßen kann.
 */
export function ensureGongCtx(): void {
  try {
    const Ctor =
      window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return;
    actx = actx || new Ctor();
    if (actx.state === "suspended" && actx.resume) void actx.resume();
  } catch {
    /* optional */
  }
}

export function gong(): void {
  try {
    ensureGongCtx();
    if (!actx) return;
    const t = actx.currentTime;
    [659.25, 987.77].forEach((freq, i) => {
      const o = actx!.createOscillator();
      const g = actx!.createGain();
      o.frequency.value = freq;
      o.type = "sine";
      g.gain.setValueAtTime(0.0001, t + i * 0.15);
      g.gain.exponentialRampToValueAtTime(0.14, t + i * 0.15 + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.15 + 1.4);
      o.connect(g);
      g.connect(actx!.destination);
      o.start(t + i * 0.15);
      o.stop(t + i * 0.15 + 1.5);
    });
  } catch {
    /* optional */
  }
}
